import { getWallets } from "../../services/walletService";

export const setWallet = () => {
    return async(dispatch) => {
        const { data } = await getWallets()
        await dispatch({ type: 'INIT-WALLETS', payload: [...data.data] })
    }
}